export default "__VITE_ASSET__v4jZo3Iq__"